import styled from 'styled-components';

import ModalFaqs from 'components/ModalFaqs/container';

export default styled(ModalFaqs)`
  .modal .content {
    max-height: 80vh !important;
    overflow: scroll !important;
  }
`;
